// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timegrid{display:grid;grid-template-columns:1fr 1fr 1fr 1fr 1fr;border:1px solid grey;padding:10px}", ""]);
// Exports
module.exports = exports;
